import {create} from 'zustand';
import {OpenConciergeIframeStore} from './types';

export const useOpenConciergeIframeStore = create<OpenConciergeIframeStore>(set => ({
	openIframeState: false,
	setOpenIframeState: value => set({openIframeState: value}),
}));
